import { cl } from '@fullcalendar/core/internal-common';
import { MeasureUnitEnum } from 'app/models';

export class UOMCategory {
    public static UOMCategoryList: Array<any> = [
        { name: 'Units', value: 'Units' },
        { name: 'Volume', value: 'Volume' },
        { name: 'Weight', value: 'Weight' },
    ];

    public static UOM: Array<any> = [
        { name: 'Milligrams', value: MeasureUnitEnum.Milligrams, category: 'Weight' },
        { name: 'Grams', value: MeasureUnitEnum.Grams, category: 'Weight' },
        { name: 'Kilograms', value: MeasureUnitEnum.Kilograms, category: 'Weight' },
        { name: 'Milliliters', value: MeasureUnitEnum.Milliliters, category: 'Volume' },
        { name: 'Liters', value: MeasureUnitEnum.Liters, category: 'Volume' },
        { name: 'Pint', value: MeasureUnitEnum.Pint, category: '' },
        { name: 'Each', value: MeasureUnitEnum.Each, category: 'Units' },
        { name: 'Pack', value: MeasureUnitEnum.Pack, category: 'Units' },
        { name: 'Carton', value: MeasureUnitEnum.Carton, category: 'Units' },
        { name: 'Bottle', value: MeasureUnitEnum.Bottle, category: 'Units' },
        { name: 'Can', value: MeasureUnitEnum.Can, category: 'Units' },
        { name: 'Kiloliters', value: MeasureUnitEnum.Kiloliters, category: 'Volume' },
        { name: 'Gallon', value: MeasureUnitEnum.Gallon, category: 'Volume' }
    ];

    public static getUOM(category: string) {
        if (category !== null && category !== undefined) {
            return this.UOM.filter(p => p.category === category);
        }
        else {
            return this.UOM;
        }
    }

    public static findUOM(value: MeasureUnitEnum) {
        const uom = this.UOM.find(p => p.value === value);
        return uom.category;
    }
}
